import { useQuery, UseQueryOptions } from 'react-query';
import { BranchPartnersService } from '../../services';
import { IBranchPartner } from '../../interfaces';

export const useBranchPartnerById = (id?: string, options?: UseQueryOptions<IBranchPartner, Error, IBranchPartner, ['branch-partner', string]>) => {
  return useQuery<IBranchPartner, Error, IBranchPartner, ['branch-partner', string]>(
    ['branch-partner', id || ''],
    async ({ queryKey }) => {
      const [, companyId] = queryKey;
      const result = await BranchPartnersService.getById(companyId);
      if (result.status === 200) return result.data;
      throw new Error(result.data as string);
    },
    // Without cacheTime: 0 a re-opened edit modal latches Formik initialValues onto the stale row.
    { cacheTime: 0, ...options },
  );
};
